<template>
  <button
    ref="refButton"
    :disabled="props.disabled"
    :class="{
      disabled: props.disabled,
      secondary: props.secondary,
      small: props.small,
    }"
    @click="emit('click')"
  >
    <div>
      <span>{{ $t(props.label) }}</span>
    </div>
  </button>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const emit = defineEmits(['click'])
const refButton = ref<HTMLElement>()

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  secondary: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
  // gamepad: {
  //   type: String,
  //   default: '',
  // },
})
</script>

<style lang="less" scoped>
button {
  text-transform: uppercase;
  // display: block;
  position: relative;
  width: 100%;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  border: 0;
  outline: 0;
  font-size: 18px;
  font-weight: bold;
  font-family: 'Noto Sans KR';

  transition: background-color 0.2s;

  color: var(--bt-enabled-text-c);
  background: var(--bt-enabled-bg-c);

  line-height: 26px;
  padding: 15px 0;
  border-radius: 4px;

  &.small {
    line-height: 23px;
    padding: 12px 16px;
    font-size: 16px;
  }

  &.secondary {
    background-color: var(--bt-secondary-bg-c);
    color: var(--text-c);
  }

  &:hover,
  &:focus,
  &.focus {
    color: var(--bt-hover-text-c);
    background: var(--bt-hover-bg-c);
    text-decoration: none;
  }

  &:active,
  &.active {
    outline: 0;
  }

  &.disabled,
  &[disabled],
  fieldset[disabled] & {
    cursor: not-allowed;
    opacity: 0.2;
    color: var(--bt-disabled-text-c);
    background: var(--bt-disabled-bg-c);
    // // .box-shadow(none);
  }
  div {
    display: inline-flex;
    align-items: center;
  }
}
</style>
